import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LazyImage } from '@/components/common';
import Drip from 'drip';
import User from 'drip/user';
import UA from 'drip/ua';
import KNB from '@dp/knb';
import { openMap } from '@/utils';
export default {
  name: 'detail-basic-new',
  components: {
    LazyImage: LazyImage
  },
  props: {
    posterUrl: String,
    // 海报图
    name: String,
    // 项目名称
    seatUrl: String,
    // 座位图
    tapStatus: {
      type: String,
      default: ''
    },
    // 标志类型
    priceList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 价格区间
    priceRangeType: Number,
    // 价格待定标识
    isMSite: Boolean,
    // 是否m站
    isWxWbQQ: Boolean,
    // 是否微信微博QQ
    preview: Boolean,
    // 是否预览
    activityType: Number,
    // 活动类型 影响tag
    performanceInfo: {
      type: Object,
      default: null
    }
  },
  mounted: function mounted() {
    if (this.isMchaoTag) {
      window.seedAction({
        bid: "b_movie_cb9svjrp_mv",
        evt: "view",
        custom: {
          performance_id: this.performanceInfo.performanceId
        }
      });
      if (this.performanceInfo.mchaoTag.abTest) {
        window.seedAction({
          bid: "b_gc_klhn8qjm_mv",
          evt: "view",
          custom: {
            douhu_abtest: this.performanceInfo.mchaoTag.abTest.expStrategy
          }
        });
      }
    }
  },
  computed: {
    normalTagsStr: function normalTagsStr() {
      return this.performanceInfo && (this.performanceInfo.normalTags || []).join(' / ');
    },
    gameProjectPlayStr: function gameProjectPlayStr() {
      if (!this.performanceInfo) return '';
      var _this$performanceInfo = this.performanceInfo,
        playerMaxNumLimit = _this$performanceInfo.playerMaxNumLimit,
        playerMinNumLimit = _this$performanceInfo.playerMinNumLimit,
        playTime = _this$performanceInfo.playTime,
        saleType = _this$performanceInfo.saleType,
        categoryId = _this$performanceInfo.categoryId;
      if (categoryId !== 14) return '';
      if (saleType === 1) {
        return "".concat(playerMinNumLimit, "-").concat(playerMaxNumLimit, " \u4EBA / ").concat(playTime, " \u5206\u949F");
      }
      return "".concat(playTime, " \u5206\u949F");
    },
    // 是否是游戏剧场项目
    isGameProject: function isGameProject() {
      return this.performanceInfo && this.performanceInfo.categoryId === 14;
    },
    // 是否是潮秀
    isMchaoTag: function isMchaoTag() {
      return this.performanceInfo.mchaoTag && this.performanceInfo.mchaoTag.isMchao;
    }
  },
  methods: {
    seatPreview: function seatPreview() {
      this.$emit('seatPreview');
    },
    goToshop: function goToshop() {
      if (!this.performanceInfo) return;
      var _this$performanceInfo2 = this.performanceInfo,
        shopId = _this$performanceInfo2.shopId,
        lat = _this$performanceInfo2.lat,
        lng = _this$performanceInfo2.lng,
        address = _this$performanceInfo2.address,
        shopName = _this$performanceInfo2.shopName;
      openMap({
        shopId: shopId,
        lat: lat,
        lng: lng,
        address: address,
        shopName: shopName
      });
    },
    gotoTop: function gotoTop(id, attr) {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_7973vwvx_mc',
        cid: 'c_c21utqjf',
        custom: {
          performance_id: this.performanceInfo.performanceId
        }
      });
      var city = this.performanceInfo.cityId || 0;
      this.go("/top/".concat(id, "?type=2&attr=").concat(attr, "&city=").concat(city), {
        _blank: true
      });
    },
    goMchaoTag: function goMchaoTag() {
      window.seedAction({
        bid: "b_movie_cb9svjrp_mc",
        evt: "click",
        custom: {
          performance_id: this.performanceInfo.performanceId
        }
      });
      var gotoUrl = this.performanceInfo.mchaoTag.jumpUrl;
      {
        // 非猫眼APP的其他原生端
        if (Drip.UA.isNative) {
          KNB.openPage({
            url: gotoUrl
          });
          return;
        }
        // 网页端
        window.location.href = gotoUrl;
      }
    }
  }
};